module.exports = __webpack_public_path__ + "images/f803c6b1.shareIcon_dark.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/sharePage/images/shareIcon_dark.webp
// module id = /eJC
// module chunks = 1